
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf-lessons",
      function () {
        return require("private-next-pages/golf-lessons/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf-lessons"])
      });
    }
  